import { connect } from 'react-redux'

import { fetchCompleteness } from 'app/sm/rental_reputation/actions'
import RentalReputation from 'app/sm/rental_reputation/container'

const mapStateToProps = ({ RentalReputation, session, Shared }) => ({
  rentalReputation: RentalReputation.rentalReputation,
  completeness: RentalReputation.completeness,
  pdf: RentalReputation.pdf,
  currentUser: session.currentUser,
  error: RentalReputation.error,
  backUrl: Shared.backUrl,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCompleteness: () => dispatch(fetchCompleteness()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RentalReputation)
